import React from 'react'
import { useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import SearchOffIcon from '@mui/icons-material/SearchOff'

/**
 * #253: what a missing document looks like now.
 *
 * Deliberately NOT the error screen. Nothing broke — the thing being asked for
 * is not there, usually because a link outlived the month it points at. The
 * copy says that plainly and offers a way on, instead of asking the reader to
 * copy technical details and send them to us.
 */
export default function DocumentNotFound({ subject, onRetry }) {
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
        padding: 3,
      }}
      data-testid="document-not-found"
    >
      <Paper elevation={3} sx={{ padding: 4, textAlign: 'center', maxWidth: 500 }}>
        <SearchOffIcon color="disabled" sx={{ fontSize: 64, marginBottom: 2 }} />
        <Typography variant="h5" gutterBottom>
          {subject || 'הפריט המבוקש'} לא נמצא
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          ייתכן שהוא נמחק, או שהקישור שהגעתם דרכו אינו מעודכן. שום נתון לא אבד.
        </Typography>
        <Box sx={{ marginTop: 3, display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Button variant="contained" onClick={() => navigate(-1)}>
            חזרה למסך הקודם
          </Button>
          {/* A read can also miss because it arrived while the document was
              being written. Without a way to look again, that transient miss
              tells the reader their month was deleted — a confident answer that
              happens to be wrong. The retry drops the cached reads first, so it
              genuinely asks Firestore again rather than re-rendering the same
              answer (#253). */}
          {onRetry && (
            <Button variant="outlined" onClick={onRetry}>
              בדיקה מחדש
            </Button>
          )}
          <Button variant="text" onClick={() => navigate('/')}>
            לדף הבית
          </Button>
        </Box>
      </Paper>
    </Box>
  )
}
